module.exports = __webpack_public_path__ + "img/courseMessage.7900fb0d.png";